import { DocumentField, SummaryCard } from '@if/mui'
import { FundingSummaryDto } from '@src/types/FundingSummaryDto'
import { User } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useFormatFundingDate } from './shared'

interface Props {
  fundingSummary: FundingSummaryDto
}

const ClientInformationCard = ({ fundingSummary }: Props) => {
  const { t } = useTranslation()
  const formatFundingDate = useFormatFundingDate()

  const borrowerName = (fundingSummary?.customerNameProvince ?? '').split(/\s*\/\s*/)[0].trim()

  return (
    <SummaryCard title={t('fundingSummary.clientInformation')} icon={User}>
      <DocumentField label={t('fundingSummary.loanNumber')} value={fundingSummary?.loanNumber} strong />
      <DocumentField
        label={t('fundingSummary.beneficiaryProvince')}
        value={fundingSummary?.customerNameProvince}
        strong
      />
      <DocumentField
        label={t('fundingSummary.applicationNumber')}
        value={fundingSummary?.referenceNumber?.toString()}
        strong
      />
      {fundingSummary?.merchantReferenceCode && (
        <DocumentField
          label={t('fundingSummary.merchantReferenceCode')}
          value={fundingSummary.merchantReferenceCode}
          strong
        />
      )}
      <DocumentField
        label={t('fundingSummary.fundingDate')}
        value={formatFundingDate(fundingSummary?.activationOn)}
        strong
      />
      <DocumentField label={t('fundingSummary.borrower')} value={borrowerName} strong />
    </SummaryCard>
  )
}

export default ClientInformationCard
